import axios from "axios";
import { BASEURL } from "../../config";
import { getAuthToken } from "../../utils/loginHandler";

export default async function getArticles(payload: any) {
  try{
    const url = `${BASEURL}crawlers/digital`;
    const token = getAuthToken();
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const config = {
      method: 'post',
      url: url,
      headers: headers,
      data: JSON.stringify(payload),
    };
    const result = await axios.request(config);      
    return result?.data;
  }
  catch(err){
    console.error("Fetch failed:", err);
    return { status: false, message: "Failed to fetch articles!" };
  }
}

export async function getArticlesByCountry(country: string) {
  try {
    const url = `${BASEURL}collection/getArticalsbyCountry`;
    const token = getAuthToken();
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const config = {
      method: 'post',
      url: url,
      headers: headers,
      data: JSON.stringify({ country }),
    };
    const result = await axios.request(config);
    
    if (result?.data?.success) {
      return { success: true, articles: result.data.articles };
    } else {
      return { success: false, message: "Failed to fetch articles by country" };
    }
  }
  catch(err) {
    console.error("Fetch articles by country failed:", err);
    return { success: false, message: "Failed to fetch articles by country!" };
  }
}
